import { Injectable, Component, ChangeDetectorRef, NgZone, ApplicationRef, ComponentFactoryResolver, Injector, ReflectiveInjector, NgModule } from '@angular/core';
import { trigger, style, state, transition, animate } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common';

function ToastrComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function ToastrComponent_div_2_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const toastr_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.removeToastr(toastr_r2)); });
    ɵngcc0.ɵɵtext(1, "\u00D7 ");
    ɵngcc0.ɵɵelementEnd();
} }
function ToastrComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toastr_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("to-title ", toastr_r2.config.titleClass || ctx_r4.titleClass, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(toastr_r2.title);
} }
function ToastrComponent_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 10);
} if (rf & 2) {
    const toastr_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("to-message ", toastr_r2.config.messageClass || ctx_r5.messageClass, "");
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r5.sanitizer.bypassSecurityTrustHtml(toastr_r2.message), ɵngcc0.ɵɵsanitizeHtml);
} }
function ToastrComponent_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toastr_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("to-message ", toastr_r2.config.messageClass || ctx_r6.messageClass, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(toastr_r2.message);
} }
function ToastrComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("@inOut.done", function ToastrComponent_div_2_Template_div_animation_inOut_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.onAnimationEnd($event)); })("click", function ToastrComponent_div_2_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const toastr_r2 = restoredCtx.$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.clicked(toastr_r2)); });
    ɵngcc0.ɵɵtemplate(1, ToastrComponent_div_2_div_1_Template, 2, 0, "div", 4);
    ɵngcc0.ɵɵtemplate(2, ToastrComponent_div_2_div_2_Template, 2, 4, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵtemplate(4, ToastrComponent_div_2_span_4_Template, 1, 4, "span", 7);
    ɵngcc0.ɵɵtemplate(5, ToastrComponent_div_2_span_5_Template, 2, 4, "span", 8);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const toastr_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("toastr toastr-", toastr_r2.type, "");
    ɵngcc0.ɵɵproperty("@inOut", toastr_r2.config.animate || ctx_r1.animate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", toastr_r2.config.showCloseButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", toastr_r2.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", toastr_r2.config.enableHTML);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", true);
} }
class ToastrOptions {
    constructor() {
        this.position = "top-right";
        this.maxShown = 5;
        this.newestOnTop = false;
        this.animate = "slideFromLeft";
        this.toastTimeout = 5000;
        this.enableHTML = false;
        this.dismiss = "auto";
        this.messageClass = "toastr-message";
        this.titleClass = "toastr-title";
        this.showCloseButton = false;
    }
}
ToastrOptions.ɵfac = function ToastrOptions_Factory(t) { return new (t || ToastrOptions)(); };
ToastrOptions.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ToastrOptions, factory: ToastrOptions.ɵfac });
/** @nocollapse */
ToastrOptions.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrOptions, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class Toastr {
    /**
     * @param {?} type
     * @param {?} message
     * @param {?=} title
     * @param {?=} data
     */
    constructor(type, message, title, data) {
        this.type = type;
        this.message = message;
        this.title = title;
        this.data = data;
        this.config = {
            position: '',
            animate: "slideFromLeft",
            dismiss: "auto",
            enableHTML: false,
            titleClass: "",
            messageClass: "",
            toastTimeout: 3000,
            showCloseButton: false
        };
    }
    /**
     * @return {?}
     */
    dismiss() {
        this.toastrManager.dismissToastr(this);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ ToastrAnimations = trigger("inOut", [
    state("fade", style({ opacity: 1 })),
    transition("void => fade", [
        style({
            opacity: 1
        }),
        animate("0.4s ease-in")
    ]),
    transition("fade => void", [
        animate("0.4s 0.1s ease-out", style({
            opacity: 0
        }))
    ]),
    state("slideFromLeft", style({ opacity: 1, transform: "translateX(0)" })),
    transition("void => slideFromLeft", [
        style({
            opacity: 0,
            transform: "translateX(-100%)"
        }),
        animate("0.4s ease-in")
    ]),
    transition("slideFromLeft => void", [
        animate("0.4s 0.1s ease-out", style({
            opacity: 0,
            transform: "translateX(100%)"
        }))
    ]),
    state("slideFromRight", style({ opacity: 1, transform: "translateX(0)" })),
    transition("void => slideFromRight", [
        style({
            opacity: 0,
            transform: "translateX(100%)"
        }),
        animate("0.4s ease-in")
    ]),
    transition("slideFromRight => void", [
        animate("0.4s 0.1s ease-out", style({
            opacity: 0,
            transform: "translateX(-100%)"
        }))
    ]),
    state("slideFromTop", style({ opacity: 1, transform: "translateY(0)" })),
    transition("void => slideFromTop", [
        style({
            opacity: 0,
            transform: "translateY(-100%)"
        }),
        animate("0.4s ease-in")
    ]),
    transition("slideFromTop => void", [
        animate("0.4s 0.1s ease-out", style({
            opacity: 0,
            transform: "translateY(100%)"
        }))
    ]),
    state("slideFromBottom", style({ opacity: 1, transform: "translateY(0)" })),
    transition("void => slideFromBottom", [
        style({
            opacity: 0,
            transform: "translateY(100%)"
        }),
        animate("0.4s ease-in")
    ]),
    transition("slideFromBottom => void", [
        animate("0.4s 0.1s ease-out", style({
            opacity: 0,
            transform: "translateY(-100%)"
        }))
    ])
]);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ToastrComponent {
    /**
     * @param {?} sanitizer
     * @param {?} cdr
     * @param {?} _zone
     * @param {?} options
     */
    constructor(sanitizer, cdr, _zone, options) {
        this.sanitizer = sanitizer;
        this.cdr = cdr;
        this._zone = _zone;
        this.toastrs = [];
        this._fresh = true;
        this._onEnter = new Subject();
        this._onExit = new Subject();
        Object.assign(this, options);
    }
    /**
     * @return {?}
     */
    onEnter() {
        return this._onEnter.asObservable();
    }
    /**
     * @return {?}
     */
    onExit() {
        return this._onExit.asObservable();
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    addToastr(toast) {
        if (this.position.indexOf("top") > 0) {
            if (this.newestOnTop) {
                this.toastrs.unshift(toast);
            }
            else {
                this.toastrs.push(toast);
            }
            if (this.toastrs.length > this.maxShown) {
                const /** @type {?} */ diff = this.toastrs.length - this.maxShown;
                if (this.newestOnTop) {
                    this.toastrs.splice(this.maxShown);
                }
                else {
                    this.toastrs.splice(0, diff);
                }
            }
        }
        else {
            this.toastrs.unshift(toast);
            if (this.toastrs.length > this.maxShown) {
                this.toastrs.splice(this.maxShown);
            }
        }
        if (this.animate === null && this._fresh) {
            this._fresh = false;
            this._onEnter.next();
            this._onEnter.complete();
        }
        this.cdr.detectChanges();
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    removeToastr(toast) {
        if (toast.timeoutId) {
            clearTimeout(toast.timeoutId);
            toast.timeoutId = null;
        }
        this.toastrs = this.toastrs.filter(t => {
            return t.id !== toast.id;
        });
    }
    /**
     * @return {?}
     */
    removeAllToasts() {
        this.toastrs.forEach((toast) => {
            clearTimeout(toast.timeoutId);
            toast.timeoutId = null;
        });
        this.toastrs = [];
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    clicked(toast) {
        if (this.onToastClicked) {
            this.onToastClicked(toast);
        }
    }
    /**
     * @return {?}
     */
    anyToast() {
        return this.toastrs.length > 0;
    }
    /**
     * @param {?} toastId
     * @return {?}
     */
    findToast(toastId) {
        for (let /** @type {?} */ toast of this.toastrs) {
            if (toast.id === toastId) {
                return toast;
            }
        }
        return null;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onAnimationEnd(event) {
        if (event.toState === "void" && !this.anyToast()) {
            this._ngExit();
        }
        else if (this._fresh && event.fromState === "void") {
            // notify when first animation is done
            this._fresh = false;
            this._zone.run(() => {
                this._onEnter.next();
                this._onEnter.complete();
            });
        }
    }
    /**
     * @return {?}
     */
    _ngExit() {
        this._zone.onMicrotaskEmpty.subscribe(() => {
            this._onExit.next();
            this._onExit.complete();
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._ngExit();
    }
}
ToastrComponent.ɵfac = function ToastrComponent_Factory(t) { return new (t || ToastrComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ToastrOptions)); };
ToastrComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToastrComponent, selectors: [["app-toastr"]], decls: 3, vars: 4, consts: [["id", "toastr-container"], ["toastrContainer", ""], [3, "class", "click", 4, "ngFor", "ngForOf"], [3, "click"], ["class", "toastr-close-button", 3, "click", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "ngSwitch"], [3, "class", "innerHTML", 4, "ngSwitchCase"], [3, "class", 4, "ngSwitchDefault"], [1, "toastr-close-button", 3, "click"], [3, "innerHTML"]], template: function ToastrComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, ToastrComponent_div_2_Template, 6, 8, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.position);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.toastrs);
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc2.NgSwitchDefault], styles: [".to-title[_ngcontent-%COMP%]{font-weight:700;font-size:16px;margin-bottom:8px;color:#fff}.to-message[_ngcontent-%COMP%]{word-wrap:break-word;font-size:14px;line-height:20px;display:block;color:#fff;background-color:transparent}.to-message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .to-message[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#fff}.to-message[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#ccc;text-decoration:none}.toastr-close-button[_ngcontent-%COMP%]{position:relative;right:-5px;top:-15px;float:right;font-size:25px;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8}.toastr-close-button[_ngcontent-%COMP%]:focus, .toastr-close-button[_ngcontent-%COMP%]:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}button.toastr-close-button[_ngcontent-%COMP%]{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.top-center[_ngcontent-%COMP%]{top:0;right:0;width:100%}.bottom-center[_ngcontent-%COMP%]{bottom:0;right:0;width:100%}.top-full-width[_ngcontent-%COMP%]{top:0;right:0;width:100%}.bottom-full-width[_ngcontent-%COMP%]{bottom:0;right:0;width:100%}.top-left[_ngcontent-%COMP%]{top:12px;left:12px}.top-right[_ngcontent-%COMP%]{top:12px;right:12px}.bottom-right[_ngcontent-%COMP%]{right:12px;bottom:12px}.bottom-left[_ngcontent-%COMP%]{bottom:12px;left:12px}#toastr-container[_ngcontent-%COMP%]{position:fixed;z-index:99999}#toastr-container[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{box-sizing:border-box}#toastr-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:relative;overflow:hidden;margin:10px 0 6px;padding:15px 15px 15px 60px;width:345px;border-radius:3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:1}#toastr-container[_ngcontent-%COMP%] > div.toastr-custom[_ngcontent-%COMP%]{padding:15px;color:#030303}#toastr-container[_ngcontent-%COMP%] > div.toastr-custom[_ngcontent-%COMP%]   .toastr-close-button[_ngcontent-%COMP%]{color:#999!important}#toastr-container[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:hover{box-shadow:0 0 12px #000;opacity:1;cursor:pointer}#toastr-container[_ngcontent-%COMP%] > .toastr-info[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toastr-container[_ngcontent-%COMP%] > .toastr-error[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toastr-container[_ngcontent-%COMP%] > .toastr-success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toastr-container[_ngcontent-%COMP%] > .toastr-warning[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toastr-container.bottom-center[_ngcontent-%COMP%] > div[_ngcontent-%COMP%], #toastr-container.top-center[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:300px;margin:10px auto}#toastr-container.bottom-full-width[_ngcontent-%COMP%] > div[_ngcontent-%COMP%], #toastr-container.top-full-width[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:96%;margin:10px auto}.toastr[_ngcontent-%COMP%]{background-color:#fff}.toastr-success[_ngcontent-%COMP%]{background-color:#51a351}.toastr-error[_ngcontent-%COMP%]{background-color:#d9534f}.toastr-info[_ngcontent-%COMP%]{background-color:#7460ee}.toastr-warning[_ngcontent-%COMP%]{background-color:#f89406}.toastr-progress[_ngcontent-%COMP%]{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}@media all and (max-width:240px){#toastr-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{padding:8px 8px 8px 50px;width:11em}#toastr-container[_ngcontent-%COMP%]   .toastr-close-button[_ngcontent-%COMP%]{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toastr-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{padding:8px 8px 8px 50px;width:18em}#toastr-container[_ngcontent-%COMP%]   .toastr-close-button[_ngcontent-%COMP%]{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toastr-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{padding:15px 15px 15px 50px;width:25em}}"], data: { animation: [ToastrAnimations] } });
/** @nocollapse */
ToastrComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: ChangeDetectorRef },
    { type: NgZone },
    { type: ToastrOptions }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrComponent, [{
        type: Component,
        args: [{ selector: "app-toastr", template: `<div #toastrContainer id="toastr-container" class="{{position}}">
  <div *ngFor="let toastr of toastrs" [@inOut]="toastr.config.animate || animate" (@inOut.done)="onAnimationEnd($event)" class="toastr toastr-{{toastr.type}}" 
  (click)="clicked(toastr)">
    <div class="toastr-close-button" *ngIf="toastr.config.showCloseButton" (click)="removeToastr(toastr)">&times;
    </div> 
    <div *ngIf="toastr.title" class="to-title {{toastr.config.titleClass || titleClass}}">{{toastr.title}}</div>
    <div [ngSwitch]="toastr.config.enableHTML">
      <span *ngSwitchCase="true" class="to-message {{toastr.config.messageClass || messageClass}}" [innerHTML]="sanitizer.bypassSecurityTrustHtml(toastr.message)"></span>
      <span *ngSwitchDefault class="to-message {{toastr.config.messageClass || messageClass}}">{{toastr.message}}</span>
    </div>             
  </div>
</div>`, animations: [ToastrAnimations], styles: [".to-title{font-weight:700;font-size:16px;margin-bottom:8px;color:#fff}.to-message{word-wrap:break-word;font-size:14px;line-height:20px;display:block;color:#fff;background-color:transparent}.to-message a,.to-message label{color:#fff}.to-message a:hover{color:#ccc;text-decoration:none}.toastr-close-button{position:relative;right:-5px;top:-15px;float:right;font-size:25px;color:#fff;-webkit-text-shadow:0 1px 0 #fff;text-shadow:0 1px 0 #fff;opacity:.8}.toastr-close-button:focus,.toastr-close-button:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.4}button.toastr-close-button{padding:0;cursor:pointer;background:0 0;border:0;-webkit-appearance:none}.top-center{top:0;right:0;width:100%}.bottom-center{bottom:0;right:0;width:100%}.top-full-width{top:0;right:0;width:100%}.bottom-full-width{bottom:0;right:0;width:100%}.top-left{top:12px;left:12px}.top-right{top:12px;right:12px}.bottom-right{right:12px;bottom:12px}.bottom-left{bottom:12px;left:12px}#toastr-container{position:fixed;z-index:99999}#toastr-container *{box-sizing:border-box}#toastr-container>div{position:relative;overflow:hidden;margin:10px 0 6px;padding:15px 15px 15px 60px;width:345px;border-radius:3px;background-position:15px;background-repeat:no-repeat;box-shadow:0 0 12px #999;color:#fff;opacity:1}#toastr-container>div.toastr-custom{padding:15px;color:#030303}#toastr-container>div.toastr-custom .toastr-close-button{color:#999!important}#toastr-container>:hover{box-shadow:0 0 12px #000;opacity:1;cursor:pointer}#toastr-container>.toastr-info{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important}#toastr-container>.toastr-error{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important}#toastr-container>.toastr-success{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important}#toastr-container>.toastr-warning{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important}#toastr-container.bottom-center>div,#toastr-container.top-center>div{width:300px;margin:10px auto}#toastr-container.bottom-full-width>div,#toastr-container.top-full-width>div{width:96%;margin:10px auto}.toastr{background-color:#fff}.toastr-success{background-color:#51a351}.toastr-error{background-color:#d9534f}.toastr-info{background-color:#7460ee}.toastr-warning{background-color:#f89406}.toastr-progress{position:absolute;left:0;bottom:0;height:4px;background-color:#000;opacity:.4}@media all and (max-width:240px){#toastr-container>div{padding:8px 8px 8px 50px;width:11em}#toastr-container .toastr-close-button{right:-.2em;top:-.2em}}@media all and (min-width:241px) and (max-width:480px){#toastr-container>div{padding:8px 8px 8px 50px;width:18em}#toastr-container .toastr-close-button{right:-.2em;top:-.2em}}@media all and (min-width:481px) and (max-width:768px){#toastr-container>div{padding:15px 15px 15px 50px;width:25em}}"] }]
    }], function () { return [{ type: ɵngcc1.DomSanitizer }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }, { type: ToastrOptions }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ToastrManager {
    /**
     * @param {?} _applicationRef
     * @param {?} _componentFactoryResolver
     * @param {?} _injector
     * @param {?} ngZone
     * @param {?} options
     */
    constructor(_applicationRef, _componentFactoryResolver, _injector, ngZone, options) {
        this._applicationRef = _applicationRef;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._injector = _injector;
        this.ngZone = ngZone;
        this.options = options;
        this.toastrContainers = [];
        this.index = 0;
        this.toastClicked = new Subject();
    }
    /**
     * @template T
     * @param {?} type
     * @param {?=} providers
     * @return {?}
     */
    createToastrComponent(type, providers = []) {
        // Resolve a factory for creating components of type `type`.
        const /** @type {?} */ factory = this._componentFactoryResolver.resolveComponentFactory(/** @type {?} */ (type));
        // Resolve and create an injector with the specified providers.
        const /** @type {?} */ _providers = ReflectiveInjector.resolve(providers);
        const /** @type {?} */ injector = ReflectiveInjector.fromResolvedProviders(_providers, this._injector);
        // Create new node for inserting into document.
        let /** @type {?} */ newNode = document.createElement("div");
        newNode.id = "toastr-node-" + Math.floor(Math.random() * 200);
        document.querySelector("body").appendChild(newNode);
        // Create a component using the previously resolved factory & injector.
        const /** @type {?} */ componentRef = factory.create(injector, [], newNode);
        // Insert new component node into document body.
        this.attachToApplication(componentRef);
        return componentRef;
    }
    /**
     * @template T
     * @param {?} componentRef
     * @return {?}
     */
    attachToApplication(componentRef) {
        this._applicationRef.attachView(componentRef.hostView);
    }
    /**
     * @template T
     * @param {?} componentRef
     * @return {?}
     */
    detachFromApplication(componentRef) {
        this._applicationRef.detachView(componentRef.hostView);
    }
    /**
     * @param {?} position
     * @return {?}
     */
    isToastrContainerExist(position) {
        if (this.toastrContainers.length > 0) {
            const /** @type {?} */ i = this.toastrContainers.findIndex(x => x.position === position);
            if (i > -1) {
                return true;
            }
        }
        return false;
    }
    /**
     * @param {?} position
     * @return {?}
     */
    getToastrComponentRef(position) {
        if (this.toastrContainers.length > 0) {
            const /** @type {?} */ container = this.toastrContainers.find(x => x.position === position);
            return container ? container.ref : null;
        }
        return null;
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    createTimeout(toast) {
        let /** @type {?} */ task;
        this.ngZone.runOutsideAngular(() => {
            task = setTimeout(() => this.ngZone.run(() => this.clearToast(toast)), toast.config.toastTimeout);
        });
        return task.toString();
    }
    /**
     * @param {?} toast
     * @param {?=} options
     * @return {?}
     */
    setupToast(toast, options) {
        toast.id = ++this.index;
        if (options && options.hasOwnProperty("toastTimeout")) {
            options.dismiss = "auto";
        }
        const /** @type {?} */ customConfig = Object.assign({}, this.options, options || {});
        Object.keys(toast.config).forEach(k => {
            if (customConfig.hasOwnProperty(k)) {
                toast.config[k] = customConfig[k];
            }
        });
        if (toast.config.dismiss === "auto") {
            toast.timeoutId = this.createTimeout(toast);
        }
        toast.toastrManager = this; // bind ToastrManager instance to Toastr
        const /** @type {?} */ position = toast.config.position;
        if (this.isToastrContainerExist(position)) {
            this.getToastrComponentRef(position).instance.addToastr(toast);
        }
        return toast;
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    clearToast(toast) {
        const /** @type {?} */ position = toast.config.position;
        if (this.isToastrContainerExist(position)) {
            let /** @type {?} */ instance = this.getToastrComponentRef(position).instance;
            instance.removeToastr(toast);
        }
    }
    /**
     * @return {?}
     */
    clearAllToasts() {
        if (this.toastrContainers.length > 0) {
            this.toastrContainers.forEach(component => {
                console.log(component);
                const /** @type {?} */ ref = component.ref;
                const /** @type {?} */ instance = component.ref.instance;
                instance.removeAllToasts();
                this.dispose(ref);
            });
        }
    }
    /**
     * @param {?} toastrComponentRef
     * @return {?}
     */
    dispose(toastrComponentRef) {
        if (toastrComponentRef) {
            const /** @type {?} */ i = this.toastrContainers.findIndex(x => x.position === toastrComponentRef.instance.position);
            if (i > -1) {
                this.toastrContainers.splice(i, 1);
            }
            this.detachFromApplication(toastrComponentRef);
        }
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    _onToastClicked(toast) {
        this.toastClicked.next(toast);
        if (toast.config.dismiss !== "controlled") {
            this.clearToast(toast);
        }
    }
    /**
     * @param {?} toast
     * @return {?}
     */
    dismissToastr(toast) {
        this.clearToast(toast);
    }
    /**
     * @return {?}
     */
    dismissAllToastr() {
        this.clearAllToasts();
    }
    /**
     * @return {?}
     */
    onClickToast() {
        return this.toastClicked.asObservable();
    }
    /**
     * @param {?} toastr
     * @param {?=} options
     * @return {?}
     */
    showToastr(toastr, options) {
        const /** @type {?} */ opt = Object.assign({}, this.options, options);
        return new Promise((resolve, reject) => {
            if (!this.isToastrContainerExist(opt.position)) {
                const /** @type {?} */ providers = [{ provide: ToastrOptions, useValue: opt }];
                let /** @type {?} */ toastrComponentRef = this.createToastrComponent(ToastrComponent, providers);
                toastrComponentRef.instance.onToastClicked = (toast) => {
                    this._onToastClicked(toast);
                };
                toastrComponentRef.instance.onExit().subscribe(() => {
                    this.dispose(toastrComponentRef);
                });
                this.toastrContainers.push({
                    position: opt.position,
                    ref: toastrComponentRef
                });
            }
            resolve(this.setupToast(toastr, options));
        });
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} options
     * @return {?}
     */
    errorToastr(message, title, options) {
        const /** @type {?} */ data = options && options.data ? options.data : null;
        const /** @type {?} */ toast = new Toastr("error", message, title, data);
        this.showToastr(toast, options);
        return toast;
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} options
     * @return {?}
     */
    infoToastr(message, title, options) {
        const /** @type {?} */ data = options && options.data ? options.data : null;
        const /** @type {?} */ toast = new Toastr("info", message, title, data);
        this.showToastr(toast, options);
        return toast;
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} options
     * @return {?}
     */
    successToastr(message, title, options) {
        const /** @type {?} */ data = options && options.data ? options.data : null;
        const /** @type {?} */ toast = new Toastr("success", message, title, data);
        this.showToastr(toast, options);
        return toast;
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} options
     * @return {?}
     */
    warningToastr(message, title, options) {
        const /** @type {?} */ data = options && options.data ? options.data : null;
        const /** @type {?} */ toast = new Toastr("warning", message, title, data);
        this.showToastr(toast, options);
        return toast;
    }
    /**
     * @param {?} message
     * @param {?=} title
     * @param {?=} options
     * @return {?}
     */
    customToastr(message, title, options) {
        const /** @type {?} */ data = options && options.data ? options.data : null;
        const /** @type {?} */ toast = new Toastr("custom", message, title, data);
        this.showToastr(toast, options);
        return toast;
    }
}
ToastrManager.ɵfac = function ToastrManager_Factory(t) { return new (t || ToastrManager)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ToastrOptions)); };
ToastrManager.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ToastrManager, factory: ToastrManager.ɵfac });
/** @nocollapse */
ToastrManager.ctorParameters = () => [
    { type: ApplicationRef },
    { type: ComponentFactoryResolver },
    { type: Injector },
    { type: NgZone },
    { type: ToastrOptions }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrManager, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: ɵngcc0.NgZone }, { type: ToastrOptions }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ToastrModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ToastrModule,
            providers: [ToastrManager, ToastrOptions]
        };
    }
}
ToastrModule.ɵfac = function ToastrModule_Factory(t) { return new (t || ToastrModule)(); };
ToastrModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToastrModule });
ToastrModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastrModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ToastrComponent],
                entryComponents: [ToastrComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastrModule, { declarations: function () { return [ToastrComponent]; }, imports: function () { return [CommonModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { ToastrModule, ToastrManager, Toastr, ToastrAnimations as ɵb, ToastrComponent as ɵa, ToastrOptions as ɵc };

